export const feeConstants = {
  FEEPLANTYPE: 'FEE_PLAN_TYPE',
  FEEMONTHLYPLANARRAY: 'FEE_MONTHLY_PLAN_ARRAY',
  FEECUSTOMPLANARRAY: 'FEE_CUSTOM_PLAN_ARRAY',
  FEEONETIMEPLANARRAY: 'FEE_ONE_TIME_PLAN_ARRAY',
  FEESTUDENTCLIENTUSERID: 'FEE_CLIENT_USER_ID',
};
